// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { LoginMutationDocument, type LoginMutation, type LoginMutationVariables } from './LoginMutation';

export async function getLoginMutationClient(variables: LoginMutationVariables) {
  return fetchGraphqlClient<LoginMutation, LoginMutationVariables>(LoginMutationDocument, "LoginMutation", { variables });
}
export const useLoginMutation = (options?: MutationOptions) => useMutation<LoginMutation, LoginMutationVariables>(getLoginMutationClient, options);